export const joystickState = {
    move: { x: 0, y: 0 },
    look: { x: 0, y: 0 }
};

export function initJoysticks() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (!isMobile) return;

    const leftContainer = document.getElementById('joystick-left');
    const rightContainer = document.getElementById('joystick-right');

    const leftJoystick = window.nipplejs.create({
        zone: leftContainer,
        mode: 'static',
        position: { left: '50%', top: '50%' },
        color: 'white',
        size: 100
    });

    leftJoystick.on('move', (evt, data) => {
        // console.log("Left joystick move:", data.vector);
        joystickState.move.x = data.vector.x;
        joystickState.move.y = data.vector.y;
    });

    leftJoystick.on('end', () => {
        joystickState.move.x = 0;
        joystickState.move.y = 0;
    });

    const rightJoystick = window.nipplejs.create({
        zone: rightContainer,
        mode: 'static',
        position: { left: '50%', top: '50%' },
        color: 'white',
        size: 100
    });

    rightJoystick.on('move', (evt, data) => {
        joystickState.look.x = data.vector.x;
        joystickState.look.y = data.vector.y;
    });

    rightJoystick.on('end', () => {
        joystickState.look.x = 0;
        joystickState.look.y = 0;
    });
}
